import React, { useEffect, useState } from "react";
import { OrganApi } from "../../../../../../api/OrganApi";
import { executePromise } from "../../../../../../util/sliceUtil";

/**
 * 기관의 교사용AI 유형(학교용/센터용)을 배지로 표시(읽기 전용).
 * 기관 목록에서 한눈에 학교/센터를 구분하기 위해 각 행이 자기 유형을 조회한다.
 */
const STYLE: Record<string, { text: string; bg: string; color: string }> = {
  SCHOOL_AFTERSCHOOL: { text: "🏫 학교용", bg: "#DBEAFE", color: "#1E40AF" },
  TRAINING_CENTER: { text: "🧠 센터용", bg: "#CCFBF1", color: "#0F766E" },
};

interface TeacherConfigResponse {
  orgType?: string;
  configured?: boolean;
}

export function OrganTeacherTypeBadge({ organIdx }: { organIdx: number }) {
  const [orgType, setOrgType] = useState<string | null>(null);
  const [configured, setConfigured] = useState<boolean>(false);

  useEffect(() => {
    let alive = true;
    executePromise<TeacherConfigResponse>(OrganApi.getOrganTeacherConfig(organIdx))
      .then((res) => {
        if (!alive) return;
        const data = res as unknown as TeacherConfigResponse;
        setOrgType(data?.orgType ?? null);
        setConfigured(!!data?.configured);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, [organIdx]);

  if (!orgType) return <span style={{ color: "#9CA3AF", fontSize: 12 }}>-</span>;
  const s = STYLE[orgType] ?? { text: orgType, bg: "#E5E7EB", color: "#374151" };
  return (
    <span
      style={{
        display: "inline-block",
        padding: "3px 10px",
        borderRadius: 999,
        background: s.bg,
        color: s.color,
        fontSize: 12,
        fontWeight: 700,
        whiteSpace: "nowrap",
      }}
    >
      {s.text}
      {!configured && <span style={{ fontWeight: 500, opacity: 0.7 }}> (기본)</span>}
    </span>
  );
}
